import Lenis from 'lenis'
import { gsap } from "gsap";
import ScrollTrigger from "gsap/ScrollTrigger";

gsap.registerPlugin(ScrollTrigger);

window.addEventListener('DOMContentLoaded', () => {
   const lenis = new Lenis();

   lenis.on('scroll', ScrollTrigger.update);

   gsap.ticker.add((time) => {
      lenis.raf(time * 1000);
   });

   gsap.ticker.lagSmoothing(0);

   // Lenis Scroll Anchors
   const scrollAnchor = document.querySelector('.lenis-anchor');
   if (scrollAnchor) {
      setTimeout(() => {
         lenis.scrollTo(scrollAnchor)
      }, 500);
   }

   // Parallax
   const parallaxParent = document.querySelector('[data-parallax-parent]');
   const parallaxUp = parallaxParent?.querySelectorAll('[data-parallax-up]');
   const parallaxDown = parallaxParent?.querySelectorAll('[data-parallax-down]');

   const parallaxAnimation = (el, percent) => gsap.from(el, {
      yPercent: percent,
      scrollTrigger: {
         trigger: parallaxParent,
         start: 'top bottom',
         end: 'bottom bottom',
         scrub: true
      }
   })

   if (parallaxParent && parallaxUp.length) {
      parallaxAnimation(parallaxUp, -200)
   }

   if (parallaxParent && parallaxDown.length) {
      parallaxAnimation(parallaxDown, 200)
   }

   // Marquee
   const marqueeParent = document.querySelectorAll('.marquee-parent');
   marqueeParent?.forEach((parent) => {
      const marqueeChildren = parent?.querySelectorAll('.marquee-child');

      if (marqueeChildren) {
         gsap.to(marqueeChildren, {
            xPercent: -100,
            duration: marqueeChildren.length * 20,
            ease: "none",
            repeat: -1,
         })
      }
   })


   // Scroll Reveal Headings
   const scrollParent = document.querySelector('#scroll-reveal');

   if (scrollParent) {
      const scrollChildren = scrollParent?.querySelectorAll('.scroll-reveal-child');
      gsap.from(scrollChildren, {
         y: 300,
         opacity: 0,
         stagger: 1,
         ease: "none",
         scrollTrigger: {
            trigger: scrollParent,
            start: "top top",
            end: () => `+=${scrollChildren.length * 300}px`,
            scrub: true,
            anticipatePin: true,
            pin: false
         }
      })
   }
})
